let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hBHEk")).then(() => parcelRequire('5W5Kk'));